import React, { useCallback, useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';

import { t } from '@/utility/localization';

import { FILE_TYPE } from '@/contexts/LibrarySetupContext/constants';

import AddContent from '../AddContent';
import OptionMenuV2 from '../OptionMenuV2';
import AddLinkModal from './AddLinkModal';
import AddSectionModal from './AddSectionModal';

const className = 'c-PortalContent-AddFolderItemSection';

const AddFolderItemSection = (props) => {
  const {
    showAddContentDiv,
    isUploadingStatus,
    onFolderItemsDrop,
    onAddUrlListSubmit,
    createSectionFolderItem,
    showAddButton = true,
    showSupportTextInDropzone = true
  } = props;

  const [openAddLinkModal, setOpenAddLinkModal] = useState(false);
  const [openAddSectionModal, setOpenAddSectionModal] = useState(false);
  const dropzoneProps = useDropzone({
    noClick: true,
    onDrop: onFolderItemsDrop
  });

  const {
    open: openFileInput,
    getRootProps,
    getInputProps
  } = dropzoneProps;

  const handleOpenAddLinkModal = () => setOpenAddLinkModal(true);
  const handleOpenAddSectionModal = () => setOpenAddSectionModal(true);
  const closeAddSectionModal = () => setOpenAddSectionModal(false);

  const handleAddSection = useCallback(
    async (formData) => {
      const { title, description } = formData;

      if (!createSectionFolderItem) return;
      await createSectionFolderItem({
        title,
        description,
        type: FILE_TYPE.SECTION
      });
      closeAddSectionModal();
    },
    [createSectionFolderItem]
  );

  const handleAddLinksSubmit = (params) => {
    onAddUrlListSubmit(params);
    setOpenAddLinkModal(false);
  };

  const options = useMemo(
    () =>
      showAddButton
        ? [
            {
              label: t('upload-file'),
              onClick: openFileInput,
              icon: 'upload-cloud-01'
            },
            {
              label: t('add-link1'),
              onClick: handleOpenAddLinkModal,
              icon: 'link-01'
            },
            {
              isDivider: true
            },
            {
              label: t('add-section'),
              onClick: handleOpenAddSectionModal,
              icon: 'folder'
            }
          ]
        : [],
    [openFileInput, showAddButton]
  );

  return (
    <div
      className={className}
      {...getRootProps({ className: 'dropzone' })}>
      <input {...getInputProps()} />
      {showAddButton && (
        <div className="mb-24 flex items-center justify-end">
          <OptionMenuV2
            options={options}
            useButtonTrigger
            buttonTriggerProps={{
              hierarchy: 'neutral_primary',
              label: t('add'),
              leadIcon: 'plus',
              disabled: isUploadingStatus
            }}
          />
        </div>
      )}

      {showAddContentDiv && (
        <div>
          <AddContent
            dropzoneProps={dropzoneProps}
            handleAddLinkSectionClick={handleOpenAddLinkModal}
            showSupportText={showSupportTextInDropzone}
          />
        </div>
      )}

      {openAddLinkModal && (
        <AddLinkModal
          open={openAddLinkModal}
          onClose={() => setOpenAddLinkModal(false)}
          onSubmit={handleAddLinksSubmit}
        />
      )}

      {openAddSectionModal && (
        <AddSectionModal
          open={openAddSectionModal}
          onClose={() => setOpenAddSectionModal(false)}
          onSubmit={handleAddSection}
        />
      )}
    </div>
  );
};

// export default AddFolderItemSection;
export default React.memo(AddFolderItemSection);
